import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import Back from "assets/images/svg/back_blue.svg";
import Filled from "assets/images/svg/filled_radio_blue.svg";
import { useModal } from "hooks";
import LinkSentDialog from "pages/security-login/components/link-sent.dialog";
import { client } from "helpers/client";
import { useQuery, useQueryClient } from "react-query";
import { Email, isBlocked } from "pages/security-login/security-login.service";
import { useStatus } from "hooks/use-status";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean,
  onHide: () => void
}

const ResetPasswordDialog = ({ show, onHide }: Props) => {
  const { t } = useTranslation("security");
  const [showLinkSent, openLinkSent, closeLinkSent] = useModal(false);
  const queryClient = useQueryClient();
  const { isLoading, load, done, stop } = useStatus();

  const {
    data: emails
  } = useQuery("emails-data", () =>
    client<Email[]>("/security/getEmails").then((r) => {
      if (r.response) return r.response;
      else return Promise.reject();
    })
  );
  const primaryEmail = emails?.find(e => e.isPrimary);


  async function handleSendForgetPassword() {
    load();
    const { response, error } = await client("/auth/forgetPassword", { data: { email: primaryEmail!.email } });
    if (response) {
      queryClient.invalidateQueries().then(() => openLinkSent());
      done();
    }
    if (error) return stop();
  }

  if (showLinkSent)
    return (
      <LinkSentDialog
        emailId={primaryEmail?.emailId}
        show={showLinkSent}
        onHide={() => {
          closeLinkSent();
          onHide();
        }}
        expire={
          isBlocked(primaryEmail?.blockTillDate)
            ? primaryEmail?.blockTillDate
            : primaryEmail?.expiryDate
        }
      />
    );

  return (
    <div>
      <Modal
        size="lg"
        centered
        show={show}
        onHide={onHide}
        className="all-modal restPassword"
      >
        <Modal.Body>
          <div className="header">
            <img src={Back} alt="back" onClick={onHide} />
            <h1>{t("reset-your-password")}</h1>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>{t("password-reset-link-sent-to-you")}</p>
              <div className="emailSelect">
                <img src={Filled} alt="Filled" />
                <p>{primaryEmail?.email}</p>
              </div>
            </div>
            <div className="col-12">
              <button disabled={isLoading} className="btn-blue" onClick={handleSendForgetPassword}>
                {isLoading && <Spinner animation="border" size="sm" />}
                {t("send")}</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ResetPasswordDialog;